<section class="flex flex-col gap-12">
  <app-section-header
    [description]="'Native Builds performance and reliability metrics'"
    [icon]="'@tui.trending-up'"
    [subtitle]="'Build Stats'"
    [title]="'Built to perform'"
  >
  </app-section-header>
  <div class="flex w-full flex-col items-center gap-6">
    @let data = statistics.data();

    <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
      <div
        class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="mb-4 flex flex-row items-center">
          <tui-icon icon="@tui.box" class="mr-2" />
          <span class="text-xl font-bold md:text-2xl"
            ><span
              [countUp]="data?.allTimeAppBuilds || 0"
              [options]="{ enableScrollSpy: true, scrollSpyOnce: true }"
              [reanimateOnClick]="false"
              >0</span
            >+</span
          >
        </div>
        <span class="text-balance text-lg">Native Builds completed</span>
        <span class="text-base text-gray-500">since launch</span>
      </div>
      <div
        class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="mb-4 flex flex-row items-center">
          <tui-icon icon="@tui.clock" class="mr-2" />
          <span class="text-xl font-bold md:text-2xl"
            ><span
              [countUp]="2"
              [options]="{ enableScrollSpy: true, scrollSpyOnce: true }"
              [reanimateOnClick]="false"
              >0</span
            >m
            <span
              [countUp]="55"
              [options]="{ enableScrollSpy: true, scrollSpyOnce: true }"
              [reanimateOnClick]="false"
              >0</span
            >s</span
          >
        </div>
        <span class="text-balance text-lg">Average build time</span>
        <span class="text-base text-gray-500">across all platforms</span>
      </div>
      <div
        class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="mb-4 flex flex-row items-center">
          <tui-icon icon="@tui.check-circle" class="mr-2" />
          <span class="text-xl font-bold md:text-2xl"
            ><span
              [countUp]="97.3"
              [options]="{
                enableScrollSpy: true,
                scrollSpyOnce: true,
                decimalPlaces: 1,
              }"
              [reanimateOnClick]="false"
              >0</span
            >%</span
          >
        </div>
        <span class="text-balance text-lg">Build success rate</span>
        <span class="text-base text-gray-500">reliable builds</span>
      </div>
    </div>
    <span class="flex items-center gap-4 text-base text-gray-500">
      <tui-pulse [tuiAppearance]="'positive'" /><span
        >Last updated {{ data?.updatedAt | timeAgo }}</span
      >
    </span>
  </div>
</section>
